import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getYAxisMaxDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateYAxisMax = currTemplateLinePlotSettings?.yAxisMax;
  const newTemplateYAxisMax = currWorkspaceLinePlotSettings?.yAxisMax;

  return {
    groupTitle: 'Y axis',
    label: 'Max',
    field: 'yAxisMax' as keyof LinePlotTemplateSettings,
    currValue: currTemplateYAxisMax,
    currDisplayValue:
      currTemplateYAxisMax == null
        ? undefined
        : currTemplateYAxisMax.toString(),
    newValue: newTemplateYAxisMax ?? DEFAULT_LINE_PLOT_SETTINGS.yAxisMax,
    newDisplayValue:
      newTemplateYAxisMax == null ? undefined : newTemplateYAxisMax.toString(),
  };
};
